import { cn } from '@utils/helpers'

export const LoadingSpinner = ({
  // SVG spinner props (original common/LoadingSpinner style)
  size = 'md',
  className = '',
  // Equalizer style props (original components/LoadingSpinner style)
  message = 'Loading...',
  fullScreen = false,
  variant = 'spinner',
}) => {
  // Equalizer variant (formerly components/LoadingSpinner.jsx)
  if (variant === 'equalizer') {
    const sizeClasses = {
      small: 'w-4 h-4',
      medium: 'w-6 h-6',
      large: 'w-8 h-8',
      xlarge: 'w-12 h-12',
    }

    const containerClasses = fullScreen
      ? 'flex flex-col items-center justify-center min-h-screen space-y-6'
      : 'flex flex-col items-center justify-center min-h-[400px] space-y-6'

    const barSize = sizeClasses[size] || sizeClasses['large']

    return (
      <div className={containerClasses}>
        {/* Equalizer-style loading animation */}
        <div className="flex items-end space-x-1">
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '0ms', animationDuration: '1s' }}></div>
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '100ms', animationDuration: '1s' }}></div>
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '200ms', animationDuration: '1s' }}></div>
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '300ms', animationDuration: '1s' }}></div>
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '400ms', animationDuration: '1s' }}></div>
          <div className={`${barSize} bg-green-800 rounded-t-sm animate-pulse`} style={{ animationDelay: '500ms', animationDuration: '1s' }}></div>
        </div>

        {/* Loading text */}
        <div className="text-center">
          <div className="text-lg font-medium text-slate-700">
            {message}
          </div>
        </div>
      </div>
    )
  }

  // Default SVG spinner variant (original common/LoadingSpinner style)
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <svg
        className={cn('animate-spin text-primary-800', sizes[size])}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  )
}

// Default export for backward compatibility with callers that use:
// import LoadingSpinner from '...'
// These callers used the old equalizer variant, so default to it.
const LoadingSpinnerDefault = ({ message = 'Loading...', size = 'large', fullScreen = false }) => (
  <LoadingSpinner variant="equalizer" message={message} size={size} fullScreen={fullScreen} />
)

export default LoadingSpinnerDefault
